module.exports = __webpack_public_path__ + "static/DSC_9249-6cfbd92dc34cee53ce66d39279f7c179.jpg";